import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { TranslocoDirective } from '@jsverse/transloco'
import { BaseIconComponent, LUCIDE_ICONS } from '@/shared/components/base/base-icon/base-icon.component'

/** Dumb chip list — the caller owns the terms and what each action means. */
@Component({
	selector: 'recent-searches',
	templateUrl: './recent-searches.component.html',
	styleUrl: './recent-searches.component.css',
	imports: [TranslocoDirective, BaseIconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecentSearchesComponent {
	readonly terms = input<string[]>([])
	readonly titleKey = input('other.recentSearches')
	/** Shown in place of the title when there are no terms; the chips and Clear all go with them. */
	readonly emptyTitleKey = input('other.noRecentSearches')

	readonly termSelected = output<string>()
	readonly termRemoved = output<string>()
	readonly clearAllClicked = output<void>()

	public readonly RemoveIcon = LUCIDE_ICONS['X']

	protected handleSelect(event: Event, term: string): void {
		// mousedown would blur the search field before the click lands.
		event.preventDefault()
		this.termSelected.emit(term)
	}

	protected handleRemove(event: Event, term: string): void {
		event.preventDefault()
		event.stopPropagation()
		this.termRemoved.emit(term)
	}

	protected handleClearAll(event: Event): void {
		event.preventDefault()
		this.clearAllClicked.emit()
	}
}
